import { render, staticRenderFns } from "./corpper.vue?vue&type=template&id=4ee63727&scoped=true&"
import script from "./corpper.vue?vue&type=script&lang=js&"
export * from "./corpper.vue?vue&type=script&lang=js&"
import style0 from "./corpper.vue?vue&type=style&index=0&id=4ee63727&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee63727",
  null
  
)

export default component.exports